var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._v(" HOME PAGE; "),_c('br'),_vm._v(" count: "+_vm._s(_vm.count)+"; "),_c('br'),_c('button',{staticClass:"btn",on:{"click":_vm.change}},[_vm._v("change")]),_c('Test')],1)}
var staticRenderFns = []

export { render, staticRenderFns }